import type { CreativeV5Type } from '../../../../apis/graphql';

export function creativeTypeToLabel(creativeType: CreativeV5Type): string {
  return `${creativeType && creativeType.includes('_') ? creativeType.split('_')[0] : creativeType || ''} CREATIVE`;
}
